import { createUseStyles } from 'react-jss';
const useIconButtonStyles = createUseStyles(() => ({
    container: {
        display: 'flex',
        border: 'none',
        borderRadius: '50%',
        padding: '0.4rem',
        cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: ({ bgColor, disabled }) => disabled ? 'transparent' : bgColor || 'rgba(255, 255, 255, 0.2)'
        }
    }
}));
export default useIconButtonStyles;
